import type { TerminalCommand } from "./types";

/** Holds the registered commands and resolves names/aliases. */
export class CommandRegistry {
  private readonly byName = new Map<string, TerminalCommand>();

  register(command: TerminalCommand): this {
    this.byName.set(command.name, command);
    command.aliases?.forEach((alias) => this.byName.set(alias, command));
    return this;
  }

  registerAll(commands: TerminalCommand[]): this {
    commands.forEach((c) => this.register(c));
    return this;
  }

  get(name: string): TerminalCommand | undefined {
    return this.byName.get(name);
  }

  /** All unique commands, in registration order. */
  all(): TerminalCommand[] {
    return [...new Set(this.byName.values())];
  }
}

export function isCommand(input: string): boolean {
  return input.trimStart().startsWith("/");
}

export interface ParsedCommand {
  name: string;
  args: string;
  argv: string[];
}

/** Splits "/use openai-1" into { name: "use", args: "openai-1", argv: [...] }. */
export function parseCommand(input: string): ParsedCommand {
  const trimmed = input.trimStart().replace(/^\//, "");
  const match = trimmed.match(/^(\S+)\s*([\s\S]*)$/);
  const name = match?.[1] ?? "";
  const args = match?.[2] ?? "";
  const argv = args.length ? args.split(/\s+/) : [];
  return { name, args, argv };
}
